import { render, staticRenderFns } from "./CardScrollable.vue?vue&type=template&id=27c9549a&"
import script from "./CardScrollable.vue?vue&type=script&lang=js&"
export * from "./CardScrollable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports